import { createContext, useContext, useState } from 'react';

import type { ReactNode } from 'react';

interface LanguageContextProps {
  currentLanguage: 'NL' | 'EN';
  switchLanguage: (currentLanguage: 'NL' | 'EN') => void;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [currentLanguage, setCurrentLanguage] = useState<'NL' | 'EN'>('EN');

  const switchLanguage = (currentLanguage: 'NL' | 'EN') => {
    setCurrentLanguage(currentLanguage);
  };

  return <LanguageContext.Provider value={{ currentLanguage, switchLanguage }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = (): LanguageContextProps => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
